import { render, staticRenderFns } from "./CategoriesForm.vue?vue&type=template&id=904bc8bc&"
import script from "./CategoriesForm.vue?vue&type=script&lang=js&"
export * from "./CategoriesForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports